import { Component, OnInit } from '@angular/core';
import {
  faEngineWarning,
} from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.scss']
})
export class NotfoundComponent implements OnInit {

  public faEngineWarning = faEngineWarning;

  constructor(
  ) { }

  ngOnInit(): void {
  }

}
